export class OrderChangeModel {
  oldOrder: number;
  newOrder: number;
  id: string;
  parentId: string;
}
